import Preloader from "@/components/Preloader/Preloader.vue";
export default {
    name: "PrivacyPolicy",
    components: {
        Preloader
    },
    data() {
        return {
            showPreloader: true
        }
    },
    mounted() {
        setTimeout(() => {
            this.showPreloader = false
        }, 500)
    },
}